/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import dateFormat from '@/tools/dateFormat';
import { twoDecimal } from '@/tools/money';
import { payBankFormatter } from '@/common/fields/bank';

export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  /*消息标题, 消息内容, 跳转内容 创建时间,推送用户, 推送渠道,推送状态,推送时间,操作,*/
  /*手机号,姓名,个体,用户类型,客户端,实名状态,钱包状态,项目名称,任务月度,任务月度,完成量,完成率,推送状态*/
  /*---------------------------------------------------------------------*/
  bankAccName: {
    label: '付款人',
    prop: 'bankAccName'
  },
  bankAcctNo: {
    label: '付款账号',
    prop: 'bankAcctNo'
  },
  companyName: {
    label: '收款人',
    prop: 'companyName'
  },
  bfBankNumber: {
    label: '收款账号',
    prop: 'bfBankNumber'
  },
  outTradeNo: {
    label: '流水号',
    prop: 'outTradeNo'
  },
  finishPayDt: {
    label: '交易日期',
    prop: 'finishPayDt',
    formatter(value) {
      return dateFormat(value.finishPayDt);
    }
  },
  //关联状态
  amount: {
    label: '金额',
    prop: 'amount',
    formatter(value) {
      return twoDecimal(value.amount, 100, '元');
    }
  },
  payPassagewayCode: {
    label: '充值通道',
    prop: 'payPassagewayCode',
    formatter(row) {
      return payBankFormatter(row);
    }
  },
  operation: {
    label: '操作',
    width: '80px',
    render: function(h, ctx, r) {
      const vm = ctx.parent;
      return (
        <div>
          <el-button
            type="text"
            disabled={!r.bankPayVoucherUrl}
            onClick={vm.$exportFile.bind(this, r.bankPayVoucherUrl)}
          >
            下载回单
          </el-button>
        </div>
      );
    }
  }
};
